export default __webpack_public_path__ + "static/Dosis-Regular-1f8722a9ca9526afbfb2c1d69d24f76a.woff2";